import React from 'react'
import { render } from 'react-dom'
import { Router } from 'react-router-dom'
import history from './modules/history'
import App from './components/app'
import store from './store/index'
import { Provider } from 'react-redux'
import registerServiceWorker from './registerServiceWorker';

import 'sanitize.css/sanitize.css'
import './index.css'

const target = document.querySelector('#root') 

render(
    <Provider store={store}>
        <Router history={history} basename={'/fissa-appuntamento'}>
            <App />
        </Router>
    </Provider>,
    target
)

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js